import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OverviewService {

  dataCache = {};

  constructor() { }


  getDataCache(timeFrame){
    return this.dataCache[timeFrame];
  }

  setDataCache(timeFrame, data){
    this.dataCache[timeFrame] = data;
  }

  clearData(){
    this.dataCache = {};
  }


}
